
        function AeaConsentBanner({ consent }) {
            const st = consent.status;
            const color = st === 'active' ? 'var(--green)' : st === 'expiring' ? 'var(--amber)' : 'var(--red)';
            const bg = st === 'active' ? 'var(--green-bg)' : st === 'expiring' ? 'var(--amber-bg)' : 'var(--red-bg)';
            const word = { active: 'Consent active', expiring: 'Consent expiring', expired: 'Consent expired', revoked: 'Consent revoked' }[st] || st;
            const tail = st === 'expired' || st === 'revoked'
                ? 'Location data is locked and retained only pending erasure.'
                : `Expires ${new Date(consent.expires_at).toLocaleDateString()} · ${consent.days_left} day${consent.days_left === 1 ? '' : 's'} left`;
            return (
                <div className="flex items-center justify-between px-5 py-3 mb-5"
                     style={{ background: bg, border: `1px solid ${color}`, borderRadius: 'var(--radius-sm)' }}>
                    <div className="flex items-center gap-3">
                        <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, display: 'inline-block' }} />
                        <span className="font-mono text-xs uppercase tracking-widest" style={{ color }}>{word}</span>
                        <span className="text-sm text-muted">— {consent.principal_name} · scope: {consent.scope === 'dsar_and_erasure' ? 'access + erasure' : 'access only'}</span>
                    </div>
                    <span className="text-xs text-muted">{tail}</span>
                </div>
            );
        }

export { AeaConsentBanner };
